var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-alert",
        {
          staticClass: "d-flex align-items-center justify-content-between",
          attrs: { show: !!_vm.alertFilter, variant: "primary" },
        },
        [
          _c("span", [
            _vm._v(
              " " +
                _vm._s(_vm.$t("Exibindo apenas vendas com o alerta")) +
                ' "' +
                _vm._s(_vm.alertFilterLabel) +
                '". '
            ),
            _vm.alertSalesOutsidePeriod
              ? _c("span", [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.$t("Vendas afetadas fora do período filtrado")
                      ) +
                      ": " +
                      _vm._s(_vm.alertSalesOutsidePeriod) +
                      ". "
                  ),
                ])
              : _vm._e(),
          ]),
          _c("e-button", {
            attrs: {
              id: "auto-delivery-monitor_clear-alert",
              size: "sm",
              variant: "outline-primary",
              icon: "x",
              text: _vm.$t("Limpar"),
            },
            on: {
              click: function ($event) {
                return _vm.$emit("clear-alert")
              },
            },
          }),
        ],
        1
      ),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { md: "3" } },
            [
              _c("FormulateInput", {
                attrs: {
                  id: "auto-delivery-monitor_sale-filter",
                  type: "text",
                  label: _vm.$t("Venda"),
                  placeholder: _vm.$t("Número da venda"),
                },
                model: {
                  value: _vm.localFilters.saleId,
                  callback: function ($$v) {
                    _vm.$set(_vm.localFilters, "saleId", $$v)
                  },
                  expression: "localFilters.saleId",
                },
              }),
            ],
            1
          ),
          _c(
            "b-col",
            { attrs: { md: "3" } },
            [
              _c("FormulateInput", {
                attrs: {
                  id: "auto-delivery-monitor_auto-state-filter",
                  type: "vue-select",
                  label: _vm.$t("Estado automático"),
                  placeholder: _vm.$t("Todos"),
                  options: _vm.options(_vm.autoDeliveryStateLabels),
                },
                model: {
                  value: _vm.localFilters.autoState,
                  callback: function ($$v) {
                    _vm.$set(_vm.localFilters, "autoState", $$v)
                  },
                  expression: "localFilters.autoState",
                },
              }),
            ],
            1
          ),
          _c(
            "b-col",
            { attrs: { md: "2" } },
            [
              _c("FormulateInput", {
                attrs: {
                  id: "auto-delivery-monitor_work-state-filter",
                  type: "vue-select",
                  label: _vm.$t("Estado do work"),
                  placeholder: _vm.$t("Todos"),
                  options: _vm.options(_vm.workStateLabels),
                },
                model: {
                  value: _vm.localFilters.workState,
                  callback: function ($$v) {
                    _vm.$set(_vm.localFilters, "workState", $$v)
                  },
                  expression: "localFilters.workState",
                },
              }),
            ],
            1
          ),
          _c(
            "b-col",
            { attrs: { md: "2" } },
            [
              _c("FormulateInput", {
                attrs: {
                  id: "auto-delivery-monitor_supplier-filter",
                  type: "vue-select",
                  label: _vm.$t("Fornecedor"),
                  placeholder: _vm.$t("Todos"),
                  options: _vm.supplierOptions,
                },
                model: {
                  value: _vm.localFilters.supplierId,
                  callback: function ($$v) {
                    _vm.$set(_vm.localFilters, "supplierId", $$v)
                  },
                  expression: "localFilters.supplierId",
                },
              }),
            ],
            1
          ),
          _c(
            "b-col",
            { staticClass: "d-flex align-items-center", attrs: { md: "2" } },
            [
              _c("FormulateInput", {
                attrs: {
                  id: "auto-delivery-monitor_only-alerts-filter",
                  type: "checkbox",
                  label: _vm.$t("Somente com alerta"),
                },
                model: {
                  value: _vm.localFilters.onlyAlerts,
                  callback: function ($$v) {
                    _vm.$set(_vm.localFilters, "onlyAlerts", $$v)
                  },
                  expression: "localFilters.onlyAlerts",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("b-table", {
        staticClass: "bordered",
        attrs: {
          "show-empty": "",
          responsive: "",
          striped: "",
          small: "",
          "empty-text": _vm.$t(
            "Nenhuma venda passou pela entrega automática no período e lojas filtrados."
          ),
          fields: _vm.fields,
          items: _vm.filteredSales,
          "per-page": _vm.perPage,
          "current-page": _vm.currentPage,
          "primary-key": "saleId",
        },
        scopedSlots: _vm._u([
          {
            key: "cell(saleId)",
            fn: function (ref) {
              var item = ref.item
              return [
                _c(
                  "b-link",
                  {
                    attrs: { id: "auto-delivery-monitor_open-" + item.saleId },
                    on: {
                      click: function ($event) {
                        return _vm.$emit("open", item.saleId)
                      },
                    },
                  },
                  [_vm._v(" #" + _vm._s(item.saleId) + " ")]
                ),
              ]
            },
          },
          {
            key: "cell(createdDate)",
            fn: function (ref) {
              var item = ref.item
              return [
                _vm._v(
                  " " + _vm._s(_vm.formatDateTime(item.createdDate)) + " "
                ),
              ]
            },
          },
          {
            key: "cell(autoDeliveryState)",
            fn: function (ref) {
              var item = ref.item
              return [
                _c(
                  "b-badge",
                  {
                    attrs: {
                      variant: _vm.variant(
                        _vm.autoDeliveryStateLabels,
                        item.autoDeliveryState
                      ),
                    },
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.$t(
                            _vm.label(
                              _vm.autoDeliveryStateLabels,
                              item.autoDeliveryState
                            )
                          )
                        ) +
                        " "
                    ),
                  ]
                ),
                item.ineligibilityReason
                  ? _c("small", { staticClass: "d-block text-muted" }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$t(
                              _vm.label(
                                _vm.ineligibilityReasonLabels,
                                item.ineligibilityReason
                              )
                            )
                          ) +
                          " "
                      ),
                    ])
                  : _vm._e(),
              ]
            },
          },
          {
            key: "cell(workState)",
            fn: function (ref) {
              var item = ref.item
              return [
                item.workState
                  ? _c(
                      "b-badge",
                      {
                        attrs: {
                          variant: _vm.variant(
                            _vm.workStateLabels,
                            item.workState
                          ),
                        },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t(
                                _vm.label(_vm.workStateLabels, item.workState)
                              )
                            ) +
                            " "
                        ),
                      ]
                    )
                  : _vm._e(),
                _c("small", { staticClass: "d-block text-muted" }, [
                  _vm._v(
                    " " +
                      _vm._s(item.workAttemptCount) +
                      " " +
                      _vm._s(_vm.$t("tentativa(s)")) +
                      " "
                  ),
                ]),
                item.workLastErrorCode
                  ? _c("small", { staticClass: "d-block text-danger" }, [
                      _vm._v(
                        " " + _vm._s(_vm.$t(item.workLastErrorCode)) + " "
                      ),
                    ])
                  : _vm._e(),
              ]
            },
          },
          {
            key: "cell(dispatches)",
            fn: function (ref) {
              var item = ref.item
              return [
                !item.dispatches.length ? _c("span", [_vm._v("-")]) : _vm._e(),
                _vm._l(item.dispatches, function (dispatch) {
                  return _c(
                    "b-badge",
                    {
                      key: dispatch.id,
                      staticClass: "mr-25 mb-25",
                      attrs: {
                        variant: dispatch.isAccepted
                          ? "success"
                          : _vm.variant(
                              _vm.dispatchStateLabels,
                              dispatch.executionState
                            ),
                        title: dispatch.supplierStatus || "",
                      },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            dispatch.deliverySupplierName ||
                              "#" + dispatch.deliverySupplierId
                          ) +
                          ": " +
                          _vm._s(
                            _vm.$t(
                              _vm.label(
                                _vm.dispatchStateLabels,
                                dispatch.executionState
                              )
                            )
                          ) +
                          " "
                      ),
                    ]
                  )
                }),
              ]
            },
          },
          {
            key: "cell(motoboyName)",
            fn: function (ref) {
              var item = ref.item
              return [_vm._v(" " + _vm._s(item.motoboyName || "-") + " ")]
            },
          },
          {
            key: "cell(deliveryStatus)",
            fn: function (ref) {
              var item = ref.item
              return [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.$t(
                        _vm.label(_vm.deliveryStatusLabels, item.deliveryStatus)
                      )
                    ) +
                    " "
                ),
              ]
            },
          },
          {
            key: "cell(age)",
            fn: function (ref) {
              var item = ref.item
              return [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.isInProgress(item)
                        ? _vm.formatAge(item.enteredPipelineAt)
                        : "-"
                    ) +
                    " "
                ),
              ]
            },
          },
          {
            key: "cell(alerts)",
            fn: function (ref) {
              var item = ref.item
              return _vm._l(item.alerts, function (alert) {
                return _c(
                  "b-badge",
                  {
                    key: alert,
                    staticClass: "mr-25 mb-25",
                    attrs: { variant: "light-danger" },
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(_vm.$t(_vm.label(_vm.alertLabels, alert))) +
                        " "
                    ),
                  ]
                )
              })
            },
          },
        ]),
      }),
      _c(
        "div",
        { staticClass: "d-flex align-items-center justify-content-between" },
        [
          _c("small", { staticClass: "text-muted" }, [
            _vm._v(
              " " +
                _vm._s(_vm.filteredSales.length) +
                " " +
                _vm._s(_vm.$t("de")) +
                " " +
                _vm._s(_vm.sales.length) +
                " " +
                _vm._s(_vm.$t("venda(s)")) +
                " "
            ),
          ]),
          _vm.filteredSales.length > _vm.perPage
            ? _c("b-pagination", {
                staticClass: "mb-0",
                attrs: {
                  "total-rows": _vm.filteredSales.length,
                  "per-page": _vm.perPage,
                },
                model: {
                  value: _vm.currentPage,
                  callback: function ($$v) {
                    _vm.currentPage = $$v
                  },
                  expression: "currentPage",
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }